import { UserRoutingStrategy, RoutingContext, NavigationDestination } from '../types';
import { User } from '@/services/platformApi';

/**
 * Routing strategy for admin users
 */
export class AdminRoutingStrategy implements UserRoutingStrategy {
  priority = 20; // Higher priority than merchant

  canHandle(user: User): boolean {
    return !!(
      user.hasAdminAccess || 
      user.isCustomerSupport ||
      user.roles?.includes('ADMIN') ||
      user.roles?.includes('SUPPORT')
    );
  }

  async getDestination(context: RoutingContext): Promise<NavigationDestination> {
    const { user, returnUrl } = context;

    // If there's a specific return URL, respect it
    if (returnUrl && this.isValidReturnUrl(returnUrl)) {
      return { path: returnUrl };
    }

    // Route based on specific admin role
    if (user.hasAdminAccess || user.roles?.includes('ADMIN')) {
      return {
        path: '/admin',
        state: { 
          fromLogin: context.fromLogin,
          role: 'admin'
        }
      };
    }

    if (user.isCustomerSupport || user.roles?.includes('SUPPORT')) {
      return {
        path: '/admin/support',
        state: { 
          fromLogin: context.fromLogin,
          role: 'support'
        }
      };
    }

    // Default admin path
    return {
      path: '/admin',
      state: { fromLogin: context.fromLogin }
    };
  }

  private isValidReturnUrl(url: string): boolean {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin;
    } catch {
      return url.startsWith('/') && !url.startsWith('//');
    }
  }
}
